/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import { defineMessages } from 'react-intl'

/* Constants */
export const key = {
  ENTER: 'Enter'
}

/* Roles */
export const role = {
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
  USER: 'user',
}

export const messages = defineMessages({
  PROMPT_PLACEHOLDER: {
    id: 'prestation.PROMPT_PLACEHOLDER',
    defaultMessage: 'PROMPT_PLACEHOLDER'  
  },
  SUMMARY_TITLE: {
    id: 'prestation.SUMMARY_TITLE',
    defaultMessage: 'SUMMARY_TITLE'  
  },
  SUMMARY_PLACEHOLDER: {
    id: 'prestation.SUMMARY_PLACEHOLDER',
    defaultMessage: 'SUMMARY_PLACEHOLDER'  
  },
  SUMMARY_DATE: {
    id: 'prestation.SUMMARY_DATE',
    defaultMessage: 'SUMMARY_DATE'  
  },
  SUMMARY_START_TIME: {
    id: 'prestation.SUMMARY_START_TIME',
    defaultMessage: 'SUMMARY_START_TIME'  
  },
  SUMMARY_END_TIME: {
    id: 'prestation.SUMMARY_END_TIME',
    defaultMessage: 'SUMMARY_END_TIME'  
  },
  SUMMARY_LANGUAGE: {
    id: 'prestation.SUMMARY_LANGUAGE',
    defaultMessage: 'SUMMARY_LANGUAGE'  
  },
  SUMMARY_ADDRESS: {
    id: 'prestation.SUMMARY_ADDRESS',
    defaultMessage: 'SUMMARY_ADDRESS'  
  },
  SUMMARY_CRITERIAS: {
    id: 'prestation.SUMMARY_CRITERIAS',
    defaultMessage: 'SUMMARY_CRITERIAS'  
  },
  SUMMARY_APPLICANT: {
    id: 'prestation.SUMMARY_APPLICANT',
    defaultMessage: 'SUMMARY_APPLICANT'  
  },
  SUMMARY_BENEFICIARY_NAME: {
    id: 'prestation.SUMMARY_BENEFICIARY_NAME',
    defaultMessage: 'SUMMARY_BENEFICIARY_NAME'  
  },
  SUMMARY_BENEFICIARY_NUMBER: {
    id: 'prestation.SUMMARY_BENEFICIARY_NUMBER',
    defaultMessage: 'SUMMARY_BENEFICIARY_NUMBER'  
  },
  SUMMARY_BENEFICIARY_TYPE: {
    id: 'prestation.SUMMARY_BENEFICIARY_TYPE',
    defaultMessage: 'SUMMARY_BENEFICIARY_TYPE'  
  },
  SUMMARY_INTERPRETER: {
    id: 'prestation.SUMMARY_INTERPRETER',
    defaultMessage: 'SUMMARY_INTERPRETER'  
  },
  SUMMARY_PREFERRED_SEX: {
    id: 'prestation.SUMMARY_PREFERRED_SEX',
    defaultMessage: 'SUMMARY_PREFERRED_SEX'  
  },
  SUMMARY_PREFERRED_NATIONALITY_ORIGIN: {
    id: 'prestation.SUMMARY_PREFERRED_NATIONALITY_ORIGIN',
    defaultMessage: 'SUMMARY_PREFERRED_NATIONALITY_ORIGIN'  
  },
  SUMMARY_PREFERRED_QUALIFICATIONS: {
    id: 'prestation.SUMMARY_PREFERRED_QUALIFICATIONS',
    defaultMessage: 'SUMMARY_PREFERRED_QUALIFICATIONS'  
  },
  SUMMARY_PREFERRED_SKILLS: {
    id: 'prestation.SUMMARY_PREFERRED_SKILLS',
    defaultMessage: 'SUMMARY_PREFERRED_SKILLS'  
  },
  CHAT_PLACEHOLDER: {
    id: 'prestation.CHAT_PLACEHOLDER',
    defaultMessage: 'CHAT_PLACEHOLDER'  
  },
  CHATBOT_HEADER: {
    id: 'prestation.CHATBOT_HEADER',
    defaultMessage: 'CHATBOT_HEADER'  
  },
  PROMPT_SEND_BUTTON: {
    id: 'prestation.PROMPT_SEND_BUTTON',
    defaultMessage: 'PROMPT_SEND_BUTTON'  
  },
  CHAT_FIELD_LABEL: {
    id: 'prestation.CHAT_FIELD_LABEL',
    defaultMessage: 'CHAT_FIELD_LABEL'  
  },
  SUMMARY_NOT_VALID: {
    id: 'prestation.SUMMARY_NOT_VALID',
    defaultMessage: 'SUMMARY_NOT_VALID'  
  },
  SUMMARY_NOT_SPECIFIED: {
    id: 'prestation.SUMMARY_NOT_SPECIFIED',
    defaultMessage: 'SUMMARY_NOT_SPECIFIED'
  },
  VALIDATE_BUTTON: {
    id: 'prestation.VALIDATE_BUTTON',
    defaultMessage: 'VALIDATE_BUTTON'  
  }
})



// WEBPACK FOOTER //
// ./src/constants/Chatbot.js